export class QualificationsMerger<
  T extends { qualification_code?: number; db_qualification_code?: number } = {}
> {
  constructor(private _qualifications: T[]) {
    this._qualifications = _qualifications || [];
  }

  public replace(substitutes: T): QualificationsMerger;
  public replace(substitutes: T[]): QualificationsMerger;
  public replace(substitutes: T | T[]): QualificationsMerger {
    substitutes = Array.isArray(substitutes) ? substitutes : [substitutes];
    for (const substitute of substitutes) {
      this._replaceEach(substitute);
    }
    return new QualificationsMerger(this._qualifications);
  }

  private _replaceEach(substitute: T) {
    this._qualifications = this._qualifications.map((q) =>
      q.qualification_code === substitute.qualification_code ||
      q.db_qualification_code === substitute.db_qualification_code
        ? substitute
        : q
    );
  }

  public merge(incoming: T): QualificationsMerger;
  public merge(incoming: T[]): QualificationsMerger;
  public merge(incoming: T | T[]): QualificationsMerger {
    incoming = Array.isArray(incoming) ? incoming : [incoming];
    return new QualificationsMerger([...this._qualifications, ...incoming]);
  }

  public get(): T[] {
    return this._qualifications;
  }
}
